import { connect } from "react-redux";
import { getSubCategories } from "common/ducks/categories";
import HomeContentVariations from "marketing/components/home_content_variations";

const mapStateToProps = ({ categories }) => {
  return {
    subCategories: getSubCategories(categories),
  };
};

export default connect(mapStateToProps)(HomeContentVariations);
